import LoginContainer from '../../LoginContainer';

export const SSOError = () => {
  return (
    <LoginContainer
      data-testid="sso-redirect"
      header="Log in"
      description={`There was an error during login.
        \n\n\nPlease contact your system administrator.`}
      includeForm={false}
    ></LoginContainer>
  );
};

export default SSOError;
